export const colors = {
  logo_orange: "#D14A1A",
  logo_green: "#1B4848",
  logo_green__low_opacity: "rgba(27, 72, 72, 0.8)",
  white: "#FFFFFF",
  gray: "#707070",
  gray__low_opacity: "rgba(112,112,112, 0.6)",
  blue__low_opacity: "rgba(70,138,126,0.3)",
  gray__dark: "#655B65",
  gray__light: "#cecece",
  gray__ultra_light: "#efefef",
  gray__extra_light: "#F7F7F7",
  gray__bit_light: "#A1A1AE",
};
